(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-information"]) return;
  try {
    
(() => {
  const productSelector = ".product-information[data-gg-b2b-order-layout], .product-information[data-product-handle='erste-hilfe-tasche-fur-den-job-teilgefullt'], .product-information[data-product-handle='geschenkbox-erste-hilfe-fur-den-job'], .product-information[data-product-handle='6x-lustige-textmarker-pastell']";
  const stickySelector = '[data-gg-sticky-registration]';
  const registrationSelector = '[data-gg-registration-box]';
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');
  let syncFrame = null;
  const origins = new WeakMap();

  const ensureOrigin = (element, attribute) => {
    let origin = origins.get(element);
    if (origin?.isConnected) return origin;
    origin = element.parentElement?.querySelector(`[${attribute}]`);

    if (!origin) {
      origin = document.createElement('span');
      origin.hidden = true;
      origin.setAttribute(attribute, '');
      element.before(origin);
    }

    origins.set(element, origin);
    return origin;
  };

  const syncSection = (section) => {
    const grid = section.querySelector('.product-information__grid');
    const media = section.querySelector('.product-information__media');
    const details = section.querySelector('.product-information__details');
    const picker = section.querySelector("variant-picker[ref='mainVariantPicker']");
    const title = section.querySelector('product-title.product-title-block');
    const price = section.querySelector('product-price.product-price-block');
    const isCube = section.hasAttribute('data-gg-cube-product');
    const isMasterOrder = section.hasAttribute('data-gg-b2b-order-layout');
    const description = isMasterOrder ? section.querySelector(".text-block[class*='product_description_']") : null;
    const orderDetails = isMasterOrder ? section.querySelector('[data-gg-b2b-order-details]') : null;
    const buyButtons = isMasterOrder ? section.querySelector('.buy-buttons-block') : null;

    if (!grid || !media || !details || !title || !price) return;
    if (isCube && !picker) return;

    const pickerOrigin = isCube ? ensureOrigin(picker, 'data-gg-cube-variant-origin') : null;
    const titleOrigin = ensureOrigin(title, 'data-gg-mobile-title-origin');
    const descriptionOrigin = description ? ensureOrigin(description, 'data-gg-mobile-description-origin') : null;

    let heading = grid.querySelector('.gg-mobile-product-heading');

    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'gg-mobile-product-heading';
    }

    if (mobileQuery.matches) {
      if (heading.parentElement !== grid) {
        grid.insertBefore(heading, media);
      }

      if (title.parentElement !== heading) {
        heading.appendChild(title);
      }

      if (description && orderDetails) {
        const destination = buyButtons && !section.querySelector(registrationSelector) ? buyButtons : orderDetails;
        if (destination.nextElementSibling !== description) destination.after(description);
      }

      if (isCube && picker.previousElementSibling !== media) {
        media.after(picker);
      }
    } else {
      if (titleOrigin.nextElementSibling !== title) {
        titleOrigin.after(title);
      }

      if (descriptionOrigin && descriptionOrigin.nextElementSibling !== description) {
        descriptionOrigin.after(description);
      }

      if (isCube && pickerOrigin.nextElementSibling !== picker) {
        pickerOrigin.after(picker);
      }

      if (heading.isConnected) {
        heading.remove();
      }
    }
  };

  const mountSticky = () => {
    const sticky = document.querySelector(stickySelector);
    if (!sticky || sticky.parentElement === document.body) return sticky;

    document.body.appendChild(sticky);
    return sticky;
  };

  const syncSticky = () => {
    const sticky = mountSticky();
    const registrationBox = document.querySelector(registrationSelector);

    if (!sticky || !registrationBox) return;

    const rect = registrationBox.getBoundingClientRect();
    const shouldShow = Boolean(
      mobileQuery.matches &&
      rect.bottom <= 0
    );

    sticky.hidden = !shouldShow;
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const syncAll = () => {
    document.querySelectorAll(productSelector).forEach(syncSection);
    syncSticky();
  };

  const queueSync = () => {
    if (syncFrame !== null) return;

    syncFrame = window.requestAnimationFrame(() => {
      syncFrame = null;
      syncAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }

  window.addEventListener('scroll', queueSync, { passive: true });
  window.addEventListener('resize', queueSync, { passive: true });
  mobileQuery.addEventListener('change', queueSync);

  document.addEventListener('variant:update', queueSync);

  document.addEventListener('shopify:section:load', queueSync);
  document.addEventListener('shopify:section:reorder', queueSync);
  document.addEventListener('shopify:block:select', queueSync);
})();

  } catch(e) { console.error(e); }
})();
})();
